

exports.__esModule = true;

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _integration = require('js/lib/integration');

var _angular = require('angular');

var _squid = require('squid');

var _auth = require('xo-models/src/auth');

var _gdprCookieBanner = require('xo-models/src/gdprCookieBanner');

var _dist = require('xo-device-info/dist');

var _thirdPartyInfo = require('xo-third-party-components/src/thirdParty-info');

var _fn = require('xo-login-components/src/login/fn');

var _utils = require('xo-login-components/src/dolphin/utils');

require('xo-ui-components/src/spinner/directive');

require('xo-page-components/src/merchant-header/directive');

require('xo-page-components/src/header/directive');

require('xo-page-components/src/footer/directive');

require('xo-page-components/src/cart/directive');

require('xo-page-components/src/gdprCookieBanner/directive');

require('xo-ui-components/src/directionality/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-validation/dist/directive');

require('xo-login-components/src/login-overlay/directive');

require('xo-login-components/src/dolphin/directive');

require('xo-third-party-components/src/venmo-stepUp/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
    tag: 'xo-checkout',
    template: _template2['default'],
    controller: function controller() {
        if (_angular.$location.path() === '/checkout') {
            _uiRouter.$state.go('checkout.review');
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            if (window.appPerformanceEvents) {
                // TimeToFirstIntractableElement: The moment client is ready to receive its first user interaction.
                // Should be the before the first promise on the page
                // If the cancel button is ready then the page is
                // ready for some user interaction
                window.appPerformanceEvents.TimeToFirstIntractableElement = parseInt(window.performance.now(), 10);
                _logger.$logger.info('APP_PERFORMANCE_EVENTS', window.appPerformanceEvents);
            }
            this.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            this.token = _angular.$rootScope.token;
            this.locale = _squid.$locale;
            this.redirectiframe = _angular.$rootScope.partnerIntegration;
            this.redirectLightbox = true;
            this.escapeHatchInContext = !_angular.$rootScope.partnerIntegration;
            this.displayHeader = true;

            this.reviewUrl = 'checkout.review';
            this.isApp = _dist.$DeviceInfo.isApp();

            this.isDolphinEligible = false;

            _angular.$document.bind('click', function (event) {
                _this.$broadcast('clickBody', event.target);
            });

            function rtl() {
                if ((0, _squid.$feature)('rtl')) {
                    _angular.$document.prop('documentElement').setAttribute('dir', _squid.$locale.metadata.directionality);
                }
            }

            this.$on('metadataChange', rtl);
            rtl();

            _fn.$fn.trigger();

            this.isGdprValid = _gdprCookieBanner.isGdprValid;
        },
        populate: function populate() {
            var _this2 = this;

            function requiresRiskyLogin(state) {
                var auth = _auth.$AuthModel.instance();

                if (auth.remembered) {
                    // riskyLogin if new state requires full auth login
                    // ignore if we're in crucial venmo Step Up states
                    return state.loginRequired && !(state.name === 'checkout.venmoAuth' || state.name === 'checkout.venmo');
                }

                return false;
            }

            function displayRiskyLogin(oldState, newState, newParams) {
                if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                    _logger.$logger.info('login_overlay_suppressed');
                    return;
                }

                var isUserinitiated = oldState.template && !oldState.name.match(/checkout\.login/);

                if (isUserinitiated) {
                    var stateName = newState && newState.name;
                    var subFlowName = stateName && stateName.replace(/^.*\./, '');

                    if (subFlowName === 'sepaAgreement') {
                        _uiRouter.$state.go('checkout.review');
                    }

                    var insufficientPermissionEvent = _thirdPartyInfo.thirdPartyExperience.getExperience(this.token) === 'VENMO_EXPERIENCE' ? '$insufficientPermissionVenmoOT' : '$insufficientPermission';

                    _angular.$rootScope.$broadcast(insufficientPermissionEvent, {
                        oldState: oldState.name,
                        newState: newState.name,
                        pageOnOverlay: newState.pageOnOverlay
                    });
                } else {
                    var auth = _auth.$AuthModel.instance();
                    var cause = newParams && newParams.message ? newParams.message : newState.name.replace(/^.*\./, '');

                    _logger.$logger.info('RISKY_LOGIN_TRANSITION_' + cause);

                    var showPasswordRecovery = (0, _squid.$feature)('pomaPasswordRecovery') && auth.password_less;
                    var transition = showPasswordRecovery ? 'checkout.createPassword' : 'checkout.login';

                    _uiRouter.$state.go(transition, {
                        targetPage: cause,
                        showNotYou: true
                    });
                }
                return false;
            }

            function displayHeader(stateName) {
                // We'll be hiding the header during the third party wallet flow, since the third Party will brand the flow from their end
                return !(stateName === 'checkout.thirdPartyWalletFlow');
            }

            var checkDolphinEligibility = function checkDolphinEligibility(stateName) {
                return (0, _utils.getDolphinEligibility)(stateName).then(function (eligibility) {
                    _this2.isDolphinEligible = eligibility;
                });
            };

            function determineOneTouchExperience() {
                var auth = _auth.$AuthModel.instance();
                var isVenmoOT = auth.get('tenant') === 'VENMO' && auth.get('remembered');
                var isPaypalOT = auth.get('tenant') !== 'VENMO' && auth.get('remembered');

                if (isVenmoOT) {
                    return 'venmo';
                } else if (isPaypalOT) {
                    return 'paypal';
                }

                return 'none';
            }

            // Check dolphin eligibility for explicit page reload
            checkDolphinEligibility(_uiRouter.$state.current && _uiRouter.$state.current.name);

            var cancelStateChangeEventListener = _angular.$rootScope.$on('$stateChangeStart', function (event, newState, newParams, oldState) {
                // venmo flag
                _this2.showVenmoExperience = _thirdPartyInfo.thirdPartyExperience.getExperience(_this2.token) === 'VENMO_EXPERIENCE';

                _logger.$logger.info('checkout_fpti', {
                    'is_venmo_branding': _this2.showVenmoExperience ? '1' : '0',
                    'is_onetouch_enabled': determineOneTouchExperience()
                });

                _this2.displayHeader = displayHeader(newState && newState.name);

                if (requiresRiskyLogin(newState)) {
                    event.preventDefault();
                    displayRiskyLogin(oldState, newState, newParams);
                }
                checkDolphinEligibility(newState && newState.name);
            });

            this.$on('$destroy', cancelStateChangeEventListener);

            if (requiresRiskyLogin(_uiRouter.$state.current)) {
                displayRiskyLogin(_uiRouter.$state.current, _uiRouter.$state.current);
            }
        }
    }
});


_uiRouter.$state;

_logger.$logger;

_integration.$integration;

_angular.$rootScope;

_angular.$document;

_angular.$location;

_squid.$Component;

_squid.$feature;

_squid.$locale;

_auth.$AuthModel;

_gdprCookieBanner.isGdprValid;

_dist.$DeviceInfo;

_thirdPartyInfo.thirdPartyExperience;

_fn.$fn;

_utils.getDolphinEligibility;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-checkout/directive.js
// module id = ./pages/xo-checkout/directive.js
// module chunks = main-code-split